module.exports = __webpack_public_path__ + "static/10.OTC Securities Trading Risk Disclosure Statement-93161838481df17bf14bf17d004a4e2a.pdf";